export default __webpack_public_path__ + "static/media/orders_deactive.45aa6b99.svg";